import Cookies from 'js-cookie'
import type { ConsentPrefs } from './consent'

export function setCookie(name: string, value: string, options?: Cookies.CookieAttributes) {
  Cookies.set(name, value, {
    secure: true,
    sameSite: 'Lax',
    ...options
  })
}

export function deleteCookie(name: string) {
  Cookies.remove(name)
}

function getUTMFromURL(): string | null {
  if (typeof window === 'undefined') return null
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('utm_source') || urlParams.get('ref') || null
}

export function applyConsentedCookies(prefs: ConsentPrefs) {
  // Essential — these are managed mostly by Supabase Auth and local session state,
  // but if we had bespoke essential cookies we would set them here.
  // For example:
  // setCookie('mf_onboarding_status', 'complete', { expires: 365 })

  // Analytics — only if consented
  if (prefs.analytics) {
    // If not set, generate a persistent anonymous ID
    if (!Cookies.get('mf_analytics')) {
      const anonId = crypto.randomUUID()
      setCookie('mf_analytics', anonId, { expires: 90 })
    }
  } else {
    // Revoke
    deleteCookie('mf_analytics')
  }

  // Attribution — only if consented
  if (prefs.attribution) {
    const utm = getUTMFromURL()
    if (utm) {
      setCookie('mf_utm_source', utm, { expires: 30 })
    }
  } else {
    // Revoke
    deleteCookie('mf_utm_source')
  }
}
